import {
  FC, useEffect, useMemo, useRef,
} from 'react'
import { Form, Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'

import style from '@src/pages/Registration/Registration.module.scss'
import { Button } from '@src/components/Button/Button'
import { Info } from '@src/components/PersonalInfo/Info'
import { AppDispatch } from '@src/store/store'
import { registration } from '@src/store/ducks/auth/thunks'
import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { validateForm } from '@src/messages/validateForm'
import { phoneRegexp } from '@src/lib/regex'
import { selectBackError } from '@src/store/ducks/auth/selectors'
import useQuery from '@src/hooks/useQuery'

const validationSchema = Yup.object().shape({
  phone: Yup.string().matches(phoneRegexp, validateForm.phone)
    .required(validateForm.required),
})
type RegistrationFormProps = {
  isLoading: boolean
}

export const RegistrationForm: FC<RegistrationFormProps> = ({ isLoading }) => {
  const formRef = useRef<any>()
  const dispatch = useDispatch<AppDispatch>()
  const backError = useSelector(selectBackError)
  const uidQuery = useQuery('uid')
  const systemNameQuery = useQuery('system_name')

  const initialValues = useMemo(() => ({
    phone: '',
    uid: uidQuery,
    systemName: systemNameQuery,
  }), [uidQuery, systemNameQuery])

  useEffect(() => {
    if (backError) {
      formRef.current.setFieldError('phone', backError)
    }
  }, [backError])

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={({ phone, uid, systemName }) => {
        dispatch(registration(phone, uid, systemName))
      }}
      innerRef={formRef}
      enableReinitialize
    >
      {() => (
        <Form>
          <div className={style.box_1}>
            <FieldFormik
              placeholder="+375 (ХХ) ХХХ ХХ ХХ"
              label="Введите ваш номер телефона"
              name="phone"
              mask="+{375} (00) 000-00-00"
            />
          </div>
          <div className={`${style.btn} ${style.posCenter}`}>
            <Button
              loading={isLoading}
              type="primary"
              className={style.btnSize}
              htmlType="submit"
            >
              Зарегистрироваться
            </Button>
          </div>
          <Info name="Зарегистрироваться" className={style.infoSize} />
        </Form>
      )}
    </Formik>
  )
}
